import { render, staticRenderFns } from "./B2bAssessmentTable.vue?vue&type=template&id=7f7e228a&scoped=true"
import script from "./B2bAssessmentTable.vue?vue&type=script&lang=js"
export * from "./B2bAssessmentTable.vue?vue&type=script&lang=js"
import style0 from "./B2bAssessmentTable.vue?vue&type=style&index=0&id=7f7e228a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7e228a",
  null
  
)

export default component.exports